import React from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  className = '' 
}) => {
  const getImageSize = () => {
    switch (size) {
      case 'small': return 32;
      case 'large': return 64;
      default: return 48;
    }
  };

  return (
    <div 
      className={`logo-container ${className}`}
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        color: 'white'
      }}
    >
      <img 
        src="/logo/logo1.png"
        alt="Pharmaco Edge Logo"
        style={{ 
          width: getImageSize(),
          height: getImageSize(),
          objectFit: 'contain',
          borderRadius: '50px'
        }} 
      />
    </div>
  );
};

export default Logo; 